import {useEffect} from 'react';

export const useAgendaDataSync = ({
  open,
  reduxData,
  dealerParticipants = [],
  setDealerParticipants,
  setFormData,
  dispatch,
  actions,
  isEditing,
}) => {
  useEffect(() => {
    if (open) {
      if (reduxData.areaSelected && reduxData.areaSelected.id) {
        const id = reduxData.areaSelected.id;
        if (!isEditing) {
          dispatch(actions.getWtsAgendaDealerLastId());
        }
        dispatch(actions.getWtsCourses({'area': id}));
        dispatch(actions.getWtsEmployeesByCharge('INSTRUCTOR'));
        dispatch(actions.getWtsDealer(id));
      }
    } else {
      setDealerParticipants([]);
    }
  }, [open, reduxData.areaSelected?.id, dispatch, actions, setDealerParticipants, isEditing]);

  useEffect(() => {
    const dealers = reduxData.wtsDealers || [];
    if (open && !isEditing && dealers.length > 0 && dealerParticipants.length === 0) {
      setDealerParticipants(dealers.map((d) => ({...d, 'count': 0})));
    }
  }, [open, reduxData.wtsDealers, dealerParticipants.length, setDealerParticipants, isEditing]);

  useEffect(() => {
    const hasLastId = reduxData.lastId && reduxData.lastId.ultimo_id !== null && reduxData.lastId.ultimo_id !== false;
    
    if (open && !isEditing && hasLastId) {
      const nextId = Number(reduxData.lastId.ultimo_id) + 1;
      setFormData((p) => {
        if (Number(p.id) !== nextId) {
          return {...p, 'id': nextId};
        }
        return p;
      });
    }
  }, [open, reduxData.lastId, setFormData, isEditing]);
};
